import React, { useState,forwardRef,useRef, useEffect } from 'react';
import { PlusOutlined,UploadOutlined,LoadingOutlined } from '@ant-design/icons';
import {Form,Input,Button,Radio,Select,Cascader,Col,message,Checkbox,Upload,Row} from 'antd';
import {Editor} from 'react-draft-wysiwyg'
import { EditorState } from 'draft-js'
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import videoService from '../../services/videoService';
import {getEditorStateFromValue,getDataFromEditor} from "../../util/common"


const VideoUpdate=((props)=> {
    const vid=props.videoID
    const [uploading, setUploading] = useState(false);
    const [loading, setLoading] = useState(false)
    const [title, setTitle] = useState("");
    const [repetitions, setRepetitions] = useState("");
    const [type, setType] = useState("");
    const [description, setDescription] = useState("")
    const [descriptionEditor, setDescriptionEditor] = useState(EditorState.createEmpty())
    const [imageUrl, setImageUrl] = useState();
    

    const videoFormRef = useRef(null);

    
    useEffect(()=>{
        
        async function fetchData() {
            const res= await videoService.getVideoInfoById(vid)
            if(res.code===0){
                const vinfo=res.data[0]
                videoFormRef.current.setFieldsValue({
                    title:vinfo.title,
                    repetitions:vinfo.repetitions,
                    type:vinfo.type===1?'Exercise':vinfo.type===2?'Warm Up':'Assessment'
                })
                setImageUrl(vinfo.picurl)
                setDescriptionEditor(getEditorStateFromValue(vinfo.description))
                setDescription(vinfo.description)
            }else{
                message.error(res.message)
            }
        }
        fetchData();
        
    },[props])


    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div
          style={{
            marginTop: 8,
          }}
        >
          Upload
        </div>
      </div>
    );
    
    const hanleClose=()=> {

        setUploading(false)

        props.handleCancel()
    }
    
    const handleInput=(evt)=>{
        setTitle(evt.target.value)
        // console.log(text)
    }
    const handleInputR=(evt)=>{
        setRepetitions(evt.target.value)
        // console.log(text)

    }

    const handleUpdate = async () => {
        // console.log("----------------------")
        videoFormRef.current.validateFields().then(res=>{
            // var tmpVType=''
            // switch(res.type){
            //   case 'Exercise':
            //     tmpVType='1'
            //     break
            //   case 'Warm Up':
            //     tmpVType='2'
            //     break
            //   case 'Assessment':
            //     tmpVType='3'
            //     break
            // }
            const tmpType=res.type==='Exercise'?1:res.type==='Warm Up'?2:3
            videoService.updateVideoInfoById(vid,res.title,tmpType,res.repetitions,description).then(result=>{
              if(result.status===0){
                hanleClose()
                props.handleRefresh()
                message.success('Successfully updated')
              }else{
                message.error('Error updating')
              }
            })
            
        }).catch(err => {console.log(err)})
    }

  return (
    <div style={{zIndex:'9999'}}>
      <Form
        labelCol={{
          span: 3,
        }}
        wrapperCol={{
          span: 25,
        }}
        layout="horizontal"
        style={{
          maxWidth: 900,
          zIndex:9999,
        }}
        ref={videoFormRef}
      >
   
        <Form.Item label="Title"
            name="title"
            rules={[{ required: true, message: 'Plese input video title!' }]}
        >
          <Input onChange={handleInput}/>
        </Form.Item>
        <Form.Item label="Type"
            name="type"
            rules={[{ required: true, message: 'Plese select video type!' }]}
        >
          <Select
            onChange={(value)=>setType(value)}
          >
            <Select.Option value="Exercise" key="1" >Exercise</Select.Option>
            <Select.Option value="Warm Up" key="2">Warm Up</Select.Option>
            <Select.Option value="Assessment" key="3">Assessment</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Repetitions"
            name="repetitions"
            rules={[{ required: true, message: 'Plese input the number of repetitions!' }]}
        >
          <Input value={repetitions} onChange={handleInputR}/>
        </Form.Item>
        <Form.Item label="Description" name="description">
        <Editor
                        
            editorStyle={{border:"1px solid #ccc",height:'100px',zIndex:'9999'}}
            editorState={descriptionEditor}
            
            // toolbarClassName='tollbarClassName'
            // wrapperClassName='wrapperClassName'
            onEditorStateChange={(editorState)=>setDescriptionEditor(editorState)}
            onBlur={()=>{
                setDescription(getDataFromEditor(descriptionEditor))
            }}
        />
        </Form.Item>
        
        <Form.Item label="Thumbnail" 
            name="avatar"
        >
          
            {imageUrl ? (
              <img
                src={imageUrl}
                alt="avatar"
                style={{
                  width: '120px',
                  height:'120px'
                }}
              />
            ) : (
              uploadButton
            )}
            
        </Form.Item>
        
        <Form.Item>
            <div style={{align: 'center'}}>

                <Button onClick={hanleClose} disabled={uploading}>Close</Button>
                <Button type="primary" 
                    onClick={handleUpdate}
                    loading={uploading}
                    style={{
                      marginLeft: 16,
                    }}
                >
                    {uploading ? 'Updating...' : 'Update & Close'}
                </Button>
            </div>
        </Form.Item>
      </Form>
    </div>
  
  )
})
export default VideoUpdate
